
import * as THREE from "../../../../libs/three.js/build/three.module.js"; 
 
import math  from "../../utils/math.js";
import {CameraAnimation} from './CameraAnimation.js' 



export class CameraAnimationCurve extends THREE.EventDispatcher{ //沿着curve轨迹的相机动画，不指定target，因视线沿着路线
    
    constructor(curve, duration, tangentDt ){//直接传入curve得到的points和UtoTMapArr
        //简单写
        super()
        this.quaFromCurveTan = true
        this.viewer = viewer 
        //this.curve = curve
        this.duration = duration
        this.cameraAniSmoothRatio = 5 //缓动系数设置小点，尽量贴合路径，尤其速度快时
        //this.newPointsPercents = UtoTMapArr.slice()
        //this.posInterpolate = true  //不直接在curve上取点，因为UtoTMapArr也是getUtoTmapping得来的， curve上getUtoTmapping后和这个不对应。否则要再算一遍pointsPercent
       
        /* this.posCurve = { points getPointAt(t){
            return curve.getPointAt(t)
        } } */
        this.posCurve = curve
        //每个点直接朝向前面那个点
        /* this.quaternions = [] 
        let quaternion, length = points.length
        for(let i=0; i<length-1; i++){
            quaternion = math.getQuaFromPosAim( points[i],  points[i+1]) 
            this.quaternions.push(quaternion) 
        }
        this.quaternions.push(quaternion)//最后一个点的朝向和前一个相同即可 */
        
        
    }
    
    setVisible(){}
    updateFrustum(){}
    
}



CameraAnimationCurve.prototype.play = CameraAnimation.prototype.play
CameraAnimationCurve.prototype.at = CameraAnimation.prototype.at
CameraAnimationCurve.prototype.set = CameraAnimation.prototype.set
CameraAnimationCurve.prototype.pause = CameraAnimation.prototype.pause




